module.exports = __webpack_public_path__ + "static/media/illus-home.f2437de1.png";